export default __webpack_public_path__ + "static/media/logo.ddfed389.svg";